class oracel {
    constructor(){

    }
    initOptions(options){
        var ipAndfield = options.config.connectString.match(/Data Source=([^;]*);/)[1];
        ipAndfield = ipAndfield.split("/");
        options.config.ip = ipAndfield[0];
        options.config.port = "1521";
        options.config.user = options.config.connectString.match(/User ID=([^;]*);/)[1];
        options.config.passWord = options.config.connectString.match(/Password=([^;]*);/)[1];
        options.config.field = ipAndfield[1];
    }
    /*
        功能：根据连接字串获取默认数据库
        connectString ： 连接字串
    */
    getDefaultDataBase(connectString){
        var arr = connectString.match(/Data Source=([^;]*);/);
        if(arr && arr.length > 0){
            var def = arr[1].split("/");
        }
        return def[1];
    }
    /*
        功能：格式化sql语句
        sql ： 连接字串
    */
    FilterSQL(sql){
        return sql;
    }
}
export default new oracel();


// WEBPACK FOOTER //
// ./src/js/backstage/fvADOModule/lib/oracel.js